document.addEventListener("DOMContentLoaded", () => {
    const typewriterTitle = document.getElementById('typewriter-title');
    const typewriterContent = document.getElementById('typewriter-content');

    if (typewriterTitle && typewriterContent) {
        console.log(typewriterContent.innerHTML.trim());
        new Typewriter(typewriterTitle, {})
            .start()
            .typeString(typewriterContent.innerHTML.trim());
    }
});
